import { GridLayout } from "@progress/kendo-react-layout";
import * as React from "react";
import { useConditionBuilder } from "@/components/ConditionBuilder/hooks/useConditionBuilder";
import type {
  ConditionEntry,
  ConditionLeaf,
} from "@/components/ConditionBuilder/types";
import ConditionAttributeField from "./ConditionAttributeField";
import ConditionMatchWithField from "./ConditionMatchWithField";
import ConditionOperatorField from "./ConditionOperatorField";
import ConditionRowActions from "./ConditionRowActions";
import ConditionValueField from "./ConditionValueField";

interface ConditionRowProps {
  arrayName: string;
  index: number;
  onRemove: (index: number) => void;
  onInsert: (index: number, value: ConditionLeaf) => void;
  onUpdate: (index: number, value: ConditionEntry) => void;
}

const FLEX = { width: "minmax(0, 1fr)" };

const ConditionRow: React.FC<ConditionRowProps> = ({
  arrayName,
  index,
  onRemove,
  onInsert,
  onUpdate,
}) => {
  const { config } = useConditionBuilder();
  const baseName = `${arrayName}.${index}`;
  const enableMatchWith = !!config.enableMatchWith;

  const cols = enableMatchWith
    ? [FLEX, FLEX, FLEX, FLEX, { width: "auto" }]
    : [FLEX, FLEX, FLEX, { width: "auto" }];

  return (
    <GridLayout
      gap={{ rows: 0, cols: 10 }}
      cols={cols}
      className="condition-builder__row"
    >
      <ConditionAttributeField fieldName={`${baseName}.attribute`} />
      <ConditionOperatorField
        fieldName={`${baseName}.operator`}
        attributeFieldName={`${baseName}.attribute`}
      />
      {enableMatchWith && (
        <ConditionMatchWithField
          fieldName={`${baseName}.matchWith`}
          attributeFieldName={`${baseName}.attribute`}
          operatorFieldName={`${baseName}.operator`}
          valueFieldName={`${baseName}.value`}
        />
      )}
      <ConditionValueField
        fieldName={`${baseName}.value`}
        attributeFieldName={`${baseName}.attribute`}
        operatorFieldName={`${baseName}.operator`}
        matchWithFieldName={
          enableMatchWith ? `${baseName}.matchWith` : undefined
        }
      />
      <ConditionRowActions
        index={index}
        arrayName={arrayName}
        onRemove={onRemove}
        onInsert={onInsert}
        onUpdate={onUpdate}
      />
    </GridLayout>
  );
};

export default ConditionRow;
